import { render, staticRenderFns } from "./payment-wizard.vue?vue&type=template&id=5f0d7333&"
import script from "./payment-wizard.vue?vue&type=script&lang=js&"
export * from "./payment-wizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports